import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import * as fromRoutingState from './store/reducers/routing.reducer';
import { RoutingEffects } from './store/effects/routing.effects';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { RecentRoutesComponent } from './containers/recent-routes/recent-routes.component';
import { RecentRoutesDisplayComponent } from './components/recent-routes-display/recent-routes-display.component';
import { RouterModule } from '@angular/router';
import { BrowserModule } from '@angular/platform-browser';
import { SharedModule } from '../../shared.module';
import { RecentFilterPipe } from '../pipes/recent-filter.pipe';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    BrowserModule,
    StoreModule.forFeature(
      fromRoutingState.ROUTING_FEATURE_KEY,
      fromRoutingState.routingReducer,
      {
        initialState: fromRoutingState.initialState,
      },
    ),
    EffectsModule.forFeature([RoutingEffects]),
  ],
  declarations: [
    RecentRoutesComponent,
    RecentRoutesDisplayComponent,
    RecentFilterPipe,
  ],
  exports: [RecentRoutesComponent],
})
export class RecentRoutesModule {}
